var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4471 0C12.6541 0 9.10744 4.45116 9.26625 9.27834C9.41883 13.9158 9.22064 19.9225 7.79559 24.8207C6.36628 29.7332 3.94866 32.845 0 33.2446V37.7553C3.94866 38.155 6.36628 41.2668 7.79559 46.1797C9.22064 51.0779 9.41883 57.0839 9.26625 61.7217C9.10744 66.5481 12.6541 71 17.4477 71H66.5592C71.3524 71 74.8981 66.5488 74.7393 61.7217C74.5871 57.0842 74.7849 51.0779 76.21 46.1797C77.6403 41.2672 80.0513 38.1547 84 37.7553V33.2446C80.0513 32.845 77.6403 29.7332 76.2103 24.8207C74.7849 19.9232 74.5871 13.9161 74.7393 9.27834C74.8981 4.45186 71.3524 0 66.5592 0H17.4464H17.4471ZM56.9494 43.705C56.9494 50.352 52.2769 54.3829 44.5226 54.3829H31.3222C30.9446 54.3828 30.5826 54.2236 30.3156 53.9403C30.0487 53.657 29.8988 53.2728 29.8988 52.8722V18.1277C29.8987 17.9293 29.9355 17.7329 30.007 17.5495C30.0786 17.3662 30.1834 17.1996 30.3156 17.0593C30.4478 16.919 30.6048 16.8077 30.7776 16.7318C30.9503 16.6558 31.1355 16.6168 31.3225 16.6168H44.4472C50.9129 16.6168 55.1562 20.3333 55.1562 26.0389C55.1562 30.0437 52.3015 33.629 48.6649 34.2567V34.466C53.616 35.0422 56.9494 38.68 56.9494 43.705ZM43.0828 21.4056H35.5566V32.6859H41.896C46.7962 32.6859 49.4986 30.5921 49.4986 26.8494C49.4986 23.3424 47.1745 21.4056 43.0828 21.4056ZM35.5566 37.1617V49.5926H43.3601C48.4618 49.5926 51.1649 47.4205 51.1649 43.338C51.1649 39.2549 48.3866 37.161 43.032 37.161H35.5566V37.1617Z",
    fill: "#7E13F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosBootstrap);
export default __webpack_public_path__ + "static/media/logos_bootstrap.889fcedbd149597a6d0ec9035599c73f.svg";
export { ForwardRef as ReactComponent };